import Constants from '../constants/Constants';

class SoundRepository {

    constructor() {
        this.soundsMap = new Map();

        let soundNames = [
            Constants.SOUND_CHAMPIONS_PAGE,
            Constants.SOUND_HOME_PAGE,
            Constants.SOUND_DEMO_CARD,
            Constants.SOUND_JOKER_CARD,
            Constants.SOUND_VIRUS_CARD,
            Constants.SOUND_STOP_CARD,
            Constants.SOUND_SWITCH_FRIEND_CARD,
            Constants.SOUND_SWITCH_STACK_CARD,
            Constants.SOUND_SURPRISE_MEAL_CARD,
            Constants.SOUND_BIRTHDAY_ATTACK_CARD,
            Constants.SOUND_TRIP_ATTACK_CARD,
            Constants.SOUND_GRANDMA_ATTACK_CARD,
            Constants.SOUND_PROTECTION_CARD,
            Constants.SOUND_BACKGROUND,
            Constants.SOUND_BUBBLE,
            Constants.SOUND_BUTTON,
            Constants.SOUND_CARD_MOVE,
            Constants.SOUND_TICK,
            Constants.SOUND_WINNING,
            Constants.SOUND_LOSING
        ];

        soundNames.forEach(soundName => {
            let folder = 'effects';
            if (soundName.includes('page')) { folder = 'pages' }
            if (soundName.includes('card')) { folder = 'cards' }

            let url = require(`../../media/audio/${folder}/${soundName}.wav`);
            this.soundsMap.set(soundName, url);
        })        
    }

    isPlaying = (audio) => {
        if (audio.currentTime > 0 && !audio.paused) {
            return true;
        }
        return false;
    }

    // BY NAME

    getSoundByName = (soundName) => {
        if (soundName === undefined || soundName === Constants.SOUND_CARD_MOVE ) { return null }

        let sound = this.soundsMap.get(soundName);

        if (!(sound instanceof Audio)) {
            sound = new Audio(sound);
            sound.volume = 0.8;
            this.soundsMap.set(soundName, sound);
        }

        return sound;
    }

    playSoundByName = (soundName) => {
        if (soundName === undefined || soundName === Constants.SOUND_CARD_MOVE ) { return null }

        let sound = this.getSoundByName(soundName);
        if (!this.isPlaying(sound)) {
            if (soundName !== Constants.SOUND_BUBBLE && soundName !== Constants.SOUND_BUTTON && soundName !== Constants.SOUND_TICK) {
                this.lowerBackgroundMusicVoliume();
                sound.play();
                sound.onended = this.backgroundMusicVoliumeToDefault; 
            }
            else {
                sound.play();
            }
        }
    }

    pauseSoundByName = (soundName) => {
        if (soundName === undefined || soundName === Constants.SOUND_CARD_MOVE ) { return null }

        let sound = this.getSoundByName(soundName);
        if (this.isPlaying(sound)) {
            sound.pause();
        }
    }

    restartSoundByName = (soundName) => {
        if (soundName === undefined || soundName === Constants.SOUND_CARD_MOVE ) { return null }

        let sound = this.getSoundByName(soundName);
        sound.currentTime = 0;
    }

    stopSoundByName = (soundName) => {
        if (soundName === undefined || soundName === Constants.SOUND_CARD_MOVE ) { return null }
        this.pauseSoundByName(soundName);
        this.restartSoundByName(soundName);
    }

    muteSoundByName = (soundName) => {
        if (soundName === undefined || soundName === Constants.SOUND_CARD_MOVE ) { return null }

        let sound = this.getSoundByName(soundName);
        sound.muted = true;
    }

    unMuteSoundByName = (soundName) => {
        if (soundName === undefined || soundName === Constants.SOUND_CARD_MOVE ) { return null }

        let sound = this.getSoundByName(soundName);
        sound.muted = false;
    }

    // BACKGROUND MUSIC

    playBackgroundMusic = () => {
        let sound = this.getSoundByName(Constants.SOUND_BACKGROUND);
        sound.loop = true;
        sound.volume = 0.6;
        sound.play();
    }

    resumeBackgroundMusic = () => {
        let sound = this.getSoundByName(Constants.SOUND_BACKGROUND);
        sound.play();
    }

    lowerBackgroundMusicVoliume = () => {
        let sound = this.getSoundByName(Constants.SOUND_BACKGROUND);
        sound.volume = 0.3; 
    }

    backgroundMusicVoliumeToDefault = () => {
        let sound = this.getSoundByName(Constants.SOUND_BACKGROUND);
        sound.volume = 0.6; 
    }

    // CARD MOVE SOUND

    getMoveCardSounds = () => {
        let soundsArr = this.soundsMap.get(Constants.SOUND_CARD_MOVE);
        let newSoundsArr = soundsArr;

        if (!(soundsArr instanceof Array)) {
            let soundSrc = soundsArr;
            newSoundsArr = [];
            // Enables to play up to TOTAL_CARDS_IN_PLAYER_HAND move_card sounds at a time
            for (let i = 0; i < Constants.TOTAL_CARDS_IN_PLAYER_HAND; i++) {
                newSoundsArr.push(new Audio(soundSrc));
            }
            this.soundsMap.set(Constants.SOUND_CARD_MOVE, newSoundsArr);
        }

        return newSoundsArr;
    }
    
    playMoveCardSound = () => {
        let soundsArr = this.getMoveCardSounds();

        for (let i = 0; i < soundsArr.length; i++) {
            let sound = soundsArr[i];
            if (!this.isPlaying(sound)) {
                sound.play();
                break;
            }
        }
    }
  
    pauseMoveCardSounds = () => {
        let soundsArr = this.getMoveCardSounds();

        for (let i = 0; i < soundsArr.length; i++) {
            let sound = soundsArr[i];
            if (this.isPlaying(sound)) {
                sound.pause();
                break;
            }
        }
    }
    
    muteMoveCardSounds = () => {
        let soundsArr = this.getMoveCardSounds();

        for (let i = 0; i < soundsArr.length; i++) {
            let sound = soundsArr[i];
            sound.muted = true;
        }
    }

    unMuteMoveCardSounds = () => {
        let soundsArr = this.getMoveCardSounds();

        for (let i = 0; i < soundsArr.length; i++) {
            let sound = soundsArr[i];
            sound.muted = false;
        }
    }

    // ALL SOUNDS

    pauseAllSounds = () => {
        for (let soundName of this.soundsMap.keys()) {
            if (soundName === Constants.SOUND_CARD_MOVE) {
                this.pauseMoveCardSounds();
            }
            else {
                this.pauseSoundByName(soundName);
            }
        }
    }

    restartAllSounds = () => {
        for (let soundName of this.soundsMap.keys()) {
            if (soundName !== Constants.SOUND_CARD_MOVE) { // unnecessary to restart move_card sounds
                this.restartSoundByName(soundName);
            }
        }
    }

    stopAllSounds = () => {
        for (let soundName of this.soundsMap.keys()) {
            if (soundName !== Constants.SOUND_CARD_MOVE && soundName !== Constants.SOUND_BACKGROUND) { // unnecessary to stop move_card sounds
                this.stopSoundByName(soundName);
            }
        }
    }

    muteAllSounds = () => {
        for (let soundName of this.soundsMap.keys()) {
            if (soundName === Constants.SOUND_CARD_MOVE) {
                this.muteMoveCardSounds();
            }
            else {
                this.muteSoundByName(soundName);
            }
        }
    }

    unMuteAllSounds = () => {
        for (let soundName of this.soundsMap.keys()) {
            if (soundName === Constants.SOUND_CARD_MOVE) {
                this.unMuteMoveCardSounds();
            }
            else {
                this.unMuteSoundByName(soundName);
            }
        }
    }
}

export default new SoundRepository();
